import React, { useState, useContext, useEffect } from "react";
import { FaEye, FaEyeSlash, FaCheck } from "react-icons/fa";
import "../style/pages/LoginPage.css";
import logoImage from '../assets/images/logo.png';
import { useNavigate, Link } from "react-router-dom";
import { login } from "../services/authService";
import { AuthContext } from "../context/AuthContext";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const { user, loginUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      if (user.user_role === "admin") {
        navigate("/admin");
      } else if (user.user_role === "user") {
        navigate("/user");
      }
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await login(username, password);
      loginUser(data);
      if (data.user_role === "admin") {
        navigate("/admin");
      } else if (data.user_role === "user") {
        navigate("/user");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-split-layout">
      {/* LEFT PANE - BLUE BRANDING */}
      <div className="login-brand-pane">
        <div className="login-brand-content">
          <p className="login-welcome-text">Welcome to</p>
          <div className="login-logo-box">
             <img className="login-img" src={logoImage} alt="Logo" />
          </div>
          <h1>HomeBox</h1>
          <p className="login-tagline">
            Securely access your home organization hub. Keep track of all your assets seamlessly and manage your space efficiently.
          </p>
          <div className="login-footer-credits">
            <span>SECURE HUB</span> <span className="login-separator">|</span> <span>VERIFIED ORG</span>
          </div>
        </div>

        {/* CLOUD DIVIDER OVERLAY */}
        <div className="login-cloud-divider">
           <svg className="login-cloud-svg login-desktop-only" preserveAspectRatio="none" viewBox="0 0 100 800" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Layer 1 (bottom/darker) */}
              <path d="M100 0H75C95 60 50 120 75 180C100 240 40 300 75 360C110 420 30 480 75 540C120 600 40 660 75 720C110 780 75 800 100 800V0Z" fill="var(--cloud-layer-1)"/>
              {/* Layer 2 (middle) */}
              <path d="M100 0H85C110 80 40 150 85 220C130 290 50 380 85 450C120 520 50 620 85 690C120 760 85 800 100 800V0Z" fill="var(--cloud-layer-2)"/>
              {/* Layer 3 (top/white) */}
              <path d="M100 0H95C130 100 40 200 95 300C150 400 30 500 95 600C160 700 80 800 100 800V0Z" fill="#ffffff"/>
           </svg>
           <svg className="login-cloud-svg login-mobile-only" preserveAspectRatio="none" viewBox="0 0 800 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 100V75C60 95 120 50 180 75C240 100 300 40 360 75C420 110 480 30 540 75C600 120 660 40 720 75C780 110 800 75 800 100H0Z" fill="var(--cloud-layer-1)"/>
              <path d="M0 100V85C80 110 150 40 220 85C290 130 380 50 450 85C520 120 620 50 690 85C760 120 800 85 800 100H0Z" fill="var(--cloud-layer-2)"/>
              <path d="M0 100V95C100 130 200 40 300 95C400 150 500 30 600 95C700 160 800 80 800 100H0Z" fill="#ffffff"/>
           </svg>
        </div>
      </div>

      {/* RIGHT PANE - WHITE FORM */}
      <div className="login-form-pane">
        <div className="login-form-container">
          <h2>Sign in to your account</h2>
          
          <form onSubmit={handleLogin} className="login-clean-form">
            <div className={`login-input-group ${username ? 'has-val' : ''}`}>
              <label>Username</label>
              <div className="login-input-field">
                <input 
                  type="text" 
                  name="username" 
                  placeholder="name@example.com" 
                  required 
                  value={username}
                  onChange={(e) => setUsername(e.target.value)} 
                />
                {username && <FaCheck className="login-check-icon" />}
              </div>
            </div>
            
            <div className={`login-input-group ${password ? 'has-val' : ''}`}>
              <label>Password</label>
              <div className="login-input-field login-password-field">
                <input 
                  type={showPassword ? "text" : "password"} 
                  name="password" 
                  placeholder="Enter your password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
                <button 
                  type="button" 
                  className="login-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>
            
            <div className="login-form-options">
              <label className="login-checkbox-container">
                <input type="checkbox" name="remember" /> 
                <span className="login-checkmark-blue">
                   <FaCheck className="login-check-svg" />
                </span>
                <span className="login-label-text">Remember me</span>
              </label>
              <a href="#" className="login-forgot-link">Forgot Password?</a>
            </div>
            
            {error && (
              <div className="login-error-text">
                {error}
              </div>
            )}

            <div className="login-button-group">
              <button type="submit" className="login-btn-solid">Sign In</button>
              <Link to="/signup" className="login-btn-outline">Sign Up</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
